import PropTypes from 'prop-types'
import { PackageIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const PackagesData = ({ loading, packagesAnalytics }) => {
  const { t } = useTranslation(['building-analytics'])

  return (
    <div className="packages-data">
      <div className="packages-data__header">
        <PackageIcon size={24} />
        <h3>{t('building-analytics:packagesData.title')}</h3>
      </div>
      {loading ? (
        <div className="loading">
          <h3>....</h3>
          <h3>{t('building-analytics:common.loading')}</h3>
        </div>
      ) : (
        <div className="packages-data__content">
          <div className="packages-data__stat">
            <span className="packages-data__label">
              {t('building-analytics:packagesData.pending')}
            </span>
            <span className="packages-data__value">{packagesAnalytics?.pending ?? 0}</span>
          </div>
          <div className="packages-data__stat">
            <span className="packages-data__label">
              {t('building-analytics:packagesData.requested')}
            </span>
            <span className="packages-data__value">{packagesAnalytics?.requested ?? 0}</span>
          </div>
        </div>
      )}
    </div>
  )
}

PackagesData.propTypes = {
  loading: PropTypes.bool,
  packagesAnalytics: PropTypes.object,
}

export default PackagesData
